import { createFileRoute } from "@tanstack/react-router";
import SecurityFindings from "@/components/SecurityFindings";

function RouteComponent() {
  return (
    <div className="p-6 min-w-0">
      <SecurityFindings />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/security/")({
  component: RouteComponent,
  staticData: { page: "engineering" },
});
